module.exports = __webpack_public_path__ + "lp/img/up-icon-level0.0acffd67.svg";